import { createContext, useContext, useState } from 'react';

const ScheduleGenerateContext = createContext();

const initialState = {
  viewState: 'form',
  selectedTab: '',
  generateResultData: null,
  accounts: [],
  hostsInRulesets: [],
  formData: null,
  openTutorialModal: true,
  popupLocation: null,
  handleHost: null,
};

const ScheduleGenerateProvider = ({ children }) => {
  const [state, setState] = useState(initialState);

  const updateState = (payload) => setState((prev) => ({ ...prev, ...payload }));
  const resetState = () => setState(initialState);

  return <ScheduleGenerateContext.Provider value={{ updateState, resetState, ...state }}>{children}</ScheduleGenerateContext.Provider>;
};

export const useScheduleGenerateState = () => {
  return useContext(ScheduleGenerateContext);
};

export default ScheduleGenerateProvider;
